<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-12">
          <label>ID da unidade</label>
          <input type="text" class="form-control" v-model="unidade.id"/>
        </div>
        <div class="col-md-12">
          <label>CNES</label>
          <div class="input-group">
            <input type="text" class="form-control" v-model="unidade.cnes" />
            <div class="input-group-append">
              <button class="btn btn-primary" type="button" @click="getCnes">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="unidade.nome" id="nome"/>
        </div>
        <div class="col-md-12">
          <label>Nome fantasia</label>
          <input type="text" class="form-control" v-model="unidade.nome_fantasia" />
        </div>
        <div class="col-md-12">
          <label>Razão social</label>
          <input type="text" class="form-control" v-model="unidade.razao_social" />
        </div>
        <div class="col-md-6">
          <label>CNPJ da entidade</label>
          <input type="text" class="form-control" v-model="unidade.cnpj_entidade" v-mask="'99.999.999/9999.99'"/>
        </div>
        <div class="col-md-6">
          <label>CNPJ da unidade</label>
          <input type="text" class="form-control" v-model="unidade.cnpj_unidade" v-mask="'99.999.999/9999.99'"/>
        </div>
        <div class="col-md-6">
          <label>Tipo de unidade</label>
          <v-select v-model="unidade.tipo_unidade_id" :options="tipo_unidade" :label="'nome'"
            :reduce="(tipo_unidade) => tipo_unidade.id" class="vselect"
          />
        </div>
        <div class="col-md-6">
          <label>Tipo da gestão</label>
          <v-select v-model="unidade.tipo_gestao" :options="tipo_gestao" :label="'nome'"
            :reduce="(tipo_gestao) => tipo_gestao.id" class="vselect"
          />
        </div>
        <div class="col-md-3">
          <label>CEP</label>
          <div class="input-group">
            <input type="text" class="form-control" v-model="unidade.cep" v-mask="'99999-999'" />
            <div class="input-group-append">
              <button class="btn btn-primary" type="button" @click="buscar">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <label>Logradouro</label>
          <input type="text" class="form-control" v-model="unidade.logradouro" />
        </div>
        <div class="col-md-2">
          <label>Número</label>
          <input type="text" class="form-control" v-model="unidade.numero"/>
        </div>
        <div class="col-md-3">
          <label>Complemento</label>
          <input type="text" class="form-control" v-model="unidade.complemento" />
        </div>
        <div class="col-md-3">
          <label>Bairro</label>
          <input type="text" class="form-control" v-model="unidade.bairro" />
        </div>
        <div class="col-md-3">
          <label>Município</label>
          <input type="text" class="form-control" v-model="unidade.municipio" />
        </div>
        <div class="col-md-3">
          <label>Estado</label>
          <input type="text" class="form-control" v-model="unidade.uf" />
        </div>
        <div class="col-md-12">
          <label>Telefone</label>
          <input type="text" class="form-control" v-model="unidade.telefone" />
        </div>
        <div class="col-md-12">
          <label>Email</label>
          <input type="text" class="form-control" v-model="unidade.email" />
        </div>
        <div class="col-md-12 text-right">
          <hr />
          <router-link to="/unidades" class="btn btn-back mr-1">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-add" @click="save">
            Salvar
            <i class="fa fa-save"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      unidade: [],
      unidade_id_original: 0,
      tipo_unidade: {},
      tipo_gestao: {},
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "unidades";

      self.$loading(true);

      if (self.unidade.unidade_id_original) {
        api += "/" + self.unidade.unidade_id_original;
      }

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );

          self.$loading(false);
 
          this.$router.push("/unidades");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("tipo_unidade_id", self.unidade.tipo_unidade_id  ? self.unidade.tipo_unidade_id  : "");
      fd.append("nome",            self.unidade.nome             ? self.unidade.nome             : "");
      fd.append("nome_fantasia",   self.unidade.nome_fantasia    ? self.unidade.nome_fantasia    : "");
      fd.append("razao_social",    self.unidade.razao_social     ? self.unidade.razao_social     : "");
      fd.append("cnes",            self.unidade.cnes             ? self.unidade.cnes             : "");
      fd.append("cnpj_entidade",   self.unidade.cnpj_entidade    ? self.unidade.cnpj_entidade    : "");
      fd.append("cnpj_unidade",    self.unidade.cnpj_unidade     ? self.unidade.cnpj_unidade     : "");
      fd.append("tipo_gestao",     self.unidade.tipo_gestao      ? self.unidade.tipo_gestao      : "");
      fd.append("cep",             self.unidade.cep              ? self.unidade.cep              : "");
      fd.append("logradouro",      self.unidade.logradouro       ? self.unidade.logradouro       : "");
      fd.append("numero",          self.unidade.numero           ? self.unidade.numero           : "");
      fd.append("bairro",          self.unidade.bairro           ? self.unidade.bairro           : "");
      fd.append("municipio",       self.unidade.municipio        ? self.unidade.municipio        : "");
      fd.append("uf",              self.unidade.uf               ? self.unidade.uf               : "");
      fd.append("telefone",        self.unidade.telefone         ? self.unidade.telefone         : "");
      fd.append("email",           self.unidade.email            ? self.unidade.email            : "");
      fd.append("_method", "POST");

      if(self.unidade.id)
      {
        fd.append("id", self.unidade.id);
      }

      if (self.unidade.unidade_id_original) {
        fd.append("_method", "PUT");
      }

      return fd;
    },
    getUnidade: function (id) {
      const self = this;
      const api = self.$store.state.api + "unidades/" + id;

      axios
        .get(api)
        .then((response) => {
          self.unidade = response.data.data[0];

          self.unidade.unidade_id_original = self.unidade.id

          self.setLoader(30);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTipoGestao: function () {
      const self = this;
      const api = self.$store.state.api + "tipo_gestoes/";

      axios
        .get(api)
        .then((response) => {
          self.tipo_gestao = response.data.data

          self.setLoader(20);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTipoUnidade: function () {
      const self = this;
      const api = self.$store.state.api + "tipo_unidades/";

      axios
        .get(api)
        .then((response) => {
          self.tipo_unidade = response.data.data

          self.setLoader(30);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      const self = this;

      self.$loading(true);

      self.unidade.logradouro = '';
      self.unidade.bairro     = '';
      self.unidade.municipio  = '';
      self.unidade.uf         = '';
      self.unidade.push();

      if (/^[0-9]{5}-[0-9]{3}$/.test(self.unidade.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + self.unidade.cep + "/json/",
          function (endereco) {

            console.log(endereco)
            self.$loading(false);

            if (endereco.erro) {
              self.endereco = {};
              $("#numero").focus();
              self.$message(null, "CEP não localizado", "error");
              return;
            }

            self.unidade.logradouro = endereco.logradouro;
            self.unidade.bairro     = endereco.bairro;
            self.unidade.municipio  = endereco.localidade;
            self.unidade.uf         = endereco.uf;
            self.unidade.push();
          }
        );
      }
    },
    getCnes: function() {
      const self = this;
      const api = self.$store.state.api + "get-cnes/" + self.unidade.cnes;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.unidade.nome_fantasia   = response.data.nome_fantasia;
          self.unidade.razao_social    = response.data.nome_razao_social;
          self.unidade.cnpj_entidade   = response.data.numero_cnpj;
          self.unidade.cnpj_unidade    = response.data.numero_cnpj_entidade;
          self.unidade.tipo_unidade_id = response.data.codigo_tipo_unidade;
          self.unidade.tipo_gestao     = response.data.tipo_gestao;
          self.unidade.cep             = response.data.codigo_cep_estabelecimento.replace(/(\d{5})(\d{3})/, "$1-$2");
          self.unidade.numero          = response.data.numero_estabelecimento;
          self.unidade.telefone        = response.data.numero_telefone_estabelecimento;
          self.unidade.email           = response.data.endereco_email_estabelecimento;


          self.unidade.push();
          self.buscar();
          self.$loading(false);
          $('#nome').focus();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.setLoader(20);
    self.getTipoUnidade();
    self.getTipoGestao();

    if (id) {
      self.getUnidade(id);
    } else {
      self.setLoader(30);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>